import { Box, Card, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import platformData from '../../../data/platforms/platform-list.json'
import { Link } from "react-router-dom";

const PlatformsList = () => {
    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                width='100%'
                spacing={{xs: 1.75, md: 3}}
            >
                {
                    platformData.en.map((item, index) => {
                        return <Grid
                            key={index}
                            size={{xs: 12, md: 6}}
                            sx={{
                                position: 'relative',
                                '&: hover': {
                                    transform: 'scale(0.99)'
                                }
                            }}
                        >
                            <ServicesBox 
                                index={index + 1}
                                title={item.name}
                                description={item.shortDescription}
                                icon={item.thumbnail}
                                themeColor={item.theme}
                                fileName={item.file}
                            />
                        </Grid>
                    })
                }
            </Grid>
        </>
    );
}

export default PlatformsList;

const ServicesBox = ({
    index,
    title,
    description,
    themeColor,
    icon,
    fileName
}) => {
    const theme = useTheme();

    return (
        <>
            <Link
                to={`/platform/${fileName}`}
                style={{
                    textDecoration: 'none'
                }}
            >
                <Card
                    elevation={3}
                    sx={{
                        p: {xs: 2, md: 5},
                        backgroundColor: theme.palette.background.default,
                        borderRadius: {xs: 4, md: 8},
                        minHeight: {xs: 0, md: 300}
                    }}
                    data-aos="zoom-in"
                    data-aos-delay={(index - 1) * 50}
                >
                    <Stack
                        direction='column'
                        justifyContent='space-between'
                        alignItems='start'
                        width='100%'
                    >
                        <Stack
                            direction='column'
                            pb={{xs: 7.5, md: 5}}
                        >
                            <Chip 
                                label={index < 10 ? `0${index}` : index} 
                                variant="contained" 
                                sx={{
                                    py: {xs: 0.5, md: 1},
                                    px: 1,
                                    width: 'fit-content',
                                    mb: {xs: 2, md: 5},
                                    backgroundColor: themeColor,
                                    color: 'white',
                                    fontWeight: 900
                                }}
                            />

                            <Typography
                                fontWeight={700}
                                fontSize={{xs: 14, md: 24}}
                                textAlign="left"
                                lineHeight={1.25}
                                sx={{
                                    pb: {xs: 1, md: 2}
                                }}
                            >
                                {title}
                            </Typography>

                            <Typography
                                fontWeight={400}
                                fontSize={{xs: 12, md: 14}}
                                textAlign="left"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                            >
                                {description}
                            </Typography>
                        </Stack>

                        <Box
                            sx={{
                                position: 'absolute', 
                                bottom: {xs: 10, md: 50},
                                height: {xs: 25, lg: 30},
                                width: {xs: 75, lg: 90}
                            }}
                        >
                            <img src={icon} alt="logo" width='100%' height='100%'/>
                        </Box>
                    </Stack>
                </Card>
            </Link>
        </>
    );
}